module.exports = __webpack_public_path__ + "img/qrcode.f59a40e4.png";